import React from 'react'
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';

export const Ldpegranules = () => {
  return (
    <>
    
{/* meta description and meta keyword start */}
<Helmet>
<title>LDPE Granules Manufacturer in Delhi | High-Quality Plastic Granules – Vanshika Plastic</title>
        {/* Meta Description for SEO */}
        <meta name="description" content="Vanshika Plastic is a trusted LDPE granules manufacturer in Delhi, offering high-quality recycled and virgin LDPE granules for film, packaging, and molding applications. Contact us for durable and cost-effective plastic raw materials." />

        {/* Meta Keywords for SEO */}
        <meta name="keywords" content="LDPE granules manufacturer in Delhi, LDPE granules supplier, recycled LDPE granules, virgin LDPE granules, LDPE plastic granules, LDPE raw material, industrial plastic granules , low-density polyethylene granules." />

        {/* Robots Meta Tag: Tells search engines whether to index and follow the page */}
        <meta name="robots" content="index, follow" />

        
        {/* Open Graph Meta Tags */}
        <meta property="og:title" content="LDPE Granules Manufacturer in Delhi | High-Quality Plastic Granules – Vanshika Plastic" />
        <meta property="og:description" content="Vanshika Plastic is a trusted LDPE granules manufacturer in Delhi, offering high-quality recycled and virgin LDPE granules for film, packaging, and molding applications. Contact us for durable and cost-effective plastic raw materials." />
        <meta property="og:image" content="https://www.vanshikaplastic.com/categoriesimg/danaimg/2.png" />
        <meta property="og:url" content="https://www.vanshikaplastic.com/Ldpegranules" />
        <meta property="og:type" content="website" />

        {/* Twitter Card Meta Tags */}
        <meta name="twitter:card" content="categoriesimg/danaimg/2.png" />
        <meta name="twitter:title" content="LDPE Granules Manufacturer in Delhi | High-Quality Plastic Granules – Vanshika Plastic" />
        <meta name="twitter:description" content="Vanshika Plastic is a trusted LDPE granules manufacturer in Delhi, offering high-quality recycled and virgin LDPE granules for film, packaging, and molding applications. Contact us for durable and cost-effective plastic raw materials." />
        <meta name="twitter:image" content="https://www.vanshikaplastic.com/categoriesimg/danaimg/2.png" />

        {/* Canonical URL Tag */}
        <link rel="canonical" href="https://www.vanshikaplastic.com/Ldpegranules" />
      </Helmet>
{/* meta description and meta keyword end */}

      {/* Page title section start */}
      <section className="page_title_mkp_section">
        <div className="page_ti_overly_mkp_div">
          <div className="container">
            <div className="row">
              {/* Column start */}
              <div className="col-xxl-12 col-xl-12 col-lg-12 col-sm-12 col-12">
                <div className="page_title_tax_mkp_main_div">
                  <div className="page_title_tax_mkp_div">
                    <h1>LDPE Granules</h1>
                    <ul>
                      <li><Link to="/">Home</Link></li>
                      <li>LDPE Granules</li>
                    </ul>
                  </div>
                </div>
              </div>
              {/* Column end */}
            </div>
          </div>
        </div>
      </section>
      {/* Page title section end */}

      {/* Product details section start */}
      <section className="products_dt_section">
        <div className="container">
          <div className="row justify-content-center">
            {/* Image section */}
            <div className="col-lg-4">
              <div className="product_details_img_box">
                <img src="../categoriesimg/danaimg/2.png"/>
              </div>
            </div>
            {/* Details section */}
            <div className="col-lg-7">
              <div className="product_dt_table">
                <h3>Specification</h3>
                <table className='table table-bordered table-striped'>
                  <tbody>

                    <tr>
                      <th>Name</th>
                     <td>LDPE Granules</td>
                    </tr>

                    <tr>
                        <th>Packaging</th>
                        <td>25 kg woven PP bags with inner liners</td>
                    </tr>

                    <tr>
                        <th>Recyclable</th>
                        <td>Yes</td>
                    </tr>

                  

                  </tbody>
                </table>
   
              </div>
              
<div className="prodt_enqyury_btn">
    <a href="/contact-us">Enquiry Now</a>
</div>
             
            </div>
          </div>
        </div>
      </section>
      {/* Product details section end */}
    </>
  )
};

export default Ldpegranules;